module.exports = __webpack_public_path__ + "img/lnb.52e99e64.jpg";